import { Box, ThemeProvider } from '@mui/material';
import { ReactNode } from 'react';
import { createCustomTheme } from 'src/theme';

import { useSettings } from '@/contexts/settings-context';

interface Props {
  children: ReactNode;
}

const AuthFormWrapper = ({ children }: Props) => {
  const { settings } = useSettings();

  const theme = createCustomTheme({
    direction: settings.direction,
    theme: 'light',
  });

  return (
    <ThemeProvider theme={theme}>
      <Box
        sx={{
          display: 'flex',
          height: '100%',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
          backgroundColor: 'black',
        }}>
        <Box
          sx={{
            width: '400px',
            background: 'white',
            borderRadius: 0.5,
          }}>
          <Box sx={{ p: 4, display: 'flex', flexDirection: 'column', gap: 2 }}>{children}</Box>
        </Box>
      </Box>
    </ThemeProvider>
  );
};

export default AuthFormWrapper;
